<script>
  import { getContext } from "svelte";
  import { client } from "sanityClient.js";

  import { query } from "svelte-apollo";
  import { _ as t } from "svelte-i18n";

  import { client as apolloClient } from "apollo.js";

  import { CONTENT_QUERY } from "./queries";

  import Event from "./Event.svelte";
  import Program from "./Program.svelte";
  import ExtraInfo from "./ExtraInfo.svelte";
  import EventVideos from "./EventVideos.svelte";
  import ConferenceDocuments from "./ConferenceDocuments.svelte";
  import ConfirmModal from "components/ConfirmModal.svelte";
  import LoginModal from "LoginModal.svelte";

  import { loginUser, forgotPassword } from "login.js";
  import { currentLang, authToken } from "stores.js";

  import { registerToEvent, unregisterFromEvent } from "./actions";
  import LoginAccount from "./LoginAccount.svelte";

  export let appLogin;
  export let appLogout;

  const registrations = query(apolloClient, { query: CONTENT_QUERY });

  const eventQuery =
    '*[_type == "event"] | order(date desc) {_id, title, teaser, date, location, address1, address2, program, files, videos, open}';
  const params = {};
  const events = client.fetch(eventQuery, params);

  const { open, close } = getContext("simple-modal");
  const handleUnregister = (e) => {
    const { eventId } = e.detail;
    unregisterFromEvent(eventId, $currentLang, "event").then(() => {
      registrations.refetch();
      open(ConfirmModal, {
        title: $t("event.unregistrationConfirmation"),
        text: $t("event.unregistrationConfirmationDetail"),
        onClose: () => {
          close();
        },
      });
    });
  };

  const handleRegister = (e) => {
    const { eventId } = e.detail;
    registerToEvent(eventId, $currentLang, "event").then((response) => {
      if (response.data.registerToEvent.sentMail) {
        open(ConfirmModal, {
          title: $t("event.registrationConfirmation"),
          text: $t("event.registrationConfirmationDetail"),
          onClose: () => {
            close();
          },
        });
      }
      registrations.refetch();
    });
  };

  const handleLoginAndRegister = (e) => {
    e.preventDefault();
    e.stopPropagation();

    open(LoginModal, {
      onLogin: (session) => {
        appLogin(session.token);
        close();
        setTimeout(() => {
          handleRegister(e);
        }, 1000);
      },
      onClose: () => {
        close();
      },
      loginUser: loginUser,
      forgotPassword: forgotPassword,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    e.stopPropagation();

    open(LoginModal, {
      onLogin: (session) => {
        appLogin(session.token);
        close();
      },
      onClose: () => {
        close();
      },
      loginUser: loginUser,
      forgotPassword: forgotPassword,
    });
  };
</script>

<LoginAccount {appLogin} {appLogout} />
<div class="wrapper">
  {#await events}
    <p>Loading...</p>
  {:then events}
    {#each events as event (event._id)}
      <Event
        {event}
        {registrations}
        on:unregister={handleUnregister}
        on:register={handleRegister}
        on:loginAndRegister={handleLoginAndRegister}
        on:login={handleLogin}
      />
      <Program programs={event.program} />
      {#if event.extraInfo2}
        <ExtraInfo info={event.extraInfo2} />
      {/if}
      <ConferenceDocuments documents={event.files} />
      {#if $authToken}
        <EventVideos videos={event.videos} />
      {/if}
    {/each}
  {:catch error}
    <p>ERROR: {error}</p>
  {/await}
</div>

<style>
  .wrapper {
    margin: 48px 0;
  }
</style>
